import { render, staticRenderFns } from "./GAvatar.vue?vue&type=template&id=f8b18b22&scoped=true"
import script from "./GAvatar.vue?vue&type=script&lang=js"
export * from "./GAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b18b22",
  null
  
)

export default component.exports